module.exports = __webpack_public_path__ + "static/img/banner-swiper2.fac0837.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-swiper2.jpg
// module id = 4g29
// module chunks = 16